import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Weddings', href: '#weddings' },
  { name: 'Catering', href: '#catering' },
  { name: 'Gallery', href: '#gallery' },
  { name: 'Contact', href: '#contact' },
];

const amenities = [
  { name: 'Ballroom', href: '#ballroom' },
  { name: 'Plaza Courtyard + Gazebo', href: '#plaza' },
  { name: 'Sunset-View Terrace', href: '#terrace' },
  { name: 'Bridal Suite', href: '#suite' },
  { name: 'Enchanted Forest', href: '#forest' },
  { name: 'Cocktail Bar and Lobby', href: '#bar' },
  { name: 'Vendor List', href: '#vendors' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [amenitiesOpen, setAmenitiesOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-brand-charcoal/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <a href="#home" className="font-serif text-xl md:text-2xl tracking-tighter transition-colors text-brand-vintage">
          Padua Weddings
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center space-x-8">
          {navLinks.slice(0, 3).map(link => (
            <a key={link.name} href={link.href} className="text-[10px] tracking-widest uppercase hover:text-brand-olive transition-colors text-brand-vintage">
              {link.name}
            </a>
          ))}
          <div
            className="relative group"
            onMouseEnter={() => setAmenitiesOpen(true)}
            onMouseLeave={() => setAmenitiesOpen(false)}
          >
            <button className="text-[10px] tracking-widest uppercase flex items-center gap-1 transition-colors group-hover:text-brand-olive text-brand-vintage">
              Amenities
              <SafeIcon icon={FiIcons.FiChevronDown} className="text-[10px]" />
            </button>
            <div className={`absolute top-full left-0 w-64 bg-brand-vintage shadow-2xl border border-brand-stone/40 py-4 transition-all duration-300 ${amenitiesOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}`}>
              {amenities.map(item => (
                <a key={item.name} href={item.href} className="block px-6 py-2.5 text-[10px] tracking-widest uppercase text-brand-charcoal hover:bg-brand-aged hover:text-brand-olive transition-colors">
                  {item.name}
                </a>
              ))}
            </div>
          </div>
          <a href="#gallery" className="text-[10px] tracking-widest uppercase hover:text-brand-olive transition-colors text-brand-vintage">Gallery</a>
          <a href="#contact" className="text-[10px] tracking-widest uppercase border px-6 py-2.5 transition-all border-brand-vintage text-brand-vintage hover:bg-brand-vintage hover:text-brand-charcoal">
            Contact Us
          </a>
        </div>

        {/* Mobile: show condensed links inline, no hamburger */}
        <div className="flex lg:hidden items-center gap-5">
          {navLinks.map(link => (
            <a
              key={link.name}
              href={link.href}
              className="text-[9px] tracking-widest uppercase text-brand-vintage hover:text-brand-olive transition-colors"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;